import { NodeRunStatuses } from '@ply-io/runner';
import RunningSVG from './assets/RunningSVG.vue';
import SuccessViSVG from './assets/SuccessViSVG.vue';
import WaitingSVG from './assets/WaitingSVG.vue';

export const STATUS_TO_SVG_MAP = {
	[NodeRunStatuses.Started]: RunningSVG,
	[NodeRunStatuses.Resumed]: RunningSVG,
	[NodeRunStatuses.Pending]: RunningSVG,
	[NodeRunStatuses.Throttled]: RunningSVG,
	[NodeRunStatuses.Waiting]: WaitingSVG,
	[NodeRunStatuses.Done]: SuccessViSVG,
};
